import { render, staticRenderFns } from "./studentRegister.vue?vue&type=template&id=85eac1ac&scoped=true&"
import script from "./studentRegister.vue?vue&type=script&lang=js&"
export * from "./studentRegister.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85eac1ac",
  null
  
)

export default component.exports